if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();

      //get arrows
      this.prevArrow = this.querySelector(".__basic-arrow__prev");
      this.nextArrow = this.querySelector(".__basic-arrow__next");

      //get images
      this.images = this.querySelectorAll(".main-product__media__item");
      this.maxStacked = this.dataset.maxStacked ? parseInt(this.dataset.maxStacked) : 1;


      this.initialNextInLine = this.images[this.maxStacked] ? this.maxStacked : null;
      this.nextInLine = this.initialNextInLine;
      this.initialLastShown = this.images[(this.maxStacked - 1)] ? (this.maxStacked - 1) : null;
      this.lastShown = this.initialLastShown;

      //get media container 
      this.stackedMedia = this.querySelector(".main-product__media__stacked");
      this.sliderTemplate = this.stackedMedia?.querySelector("template");

      //set variables for logic
      this.offset = 0;

      if (this.images.length > this.maxStacked && this.sliderTemplate) {
        this.init();
      }
    }

    init() {

      this.buildSlider();

      this.prevArrow.addEventListener('click', () => {
        if (this.nextInLine != null){
          this.offset = this.offset - this.images[this.nextInLine].getBoundingClientRect().height;
          this.images.forEach((image) => {
            image.style.transform = `translateY(${this.offset}px)`; 
          });

          this.lastShown = this.nextInLine;
          this.nextInLine = !this.images[this.nextInLine + 1] ? null : this.nextInLine + 1;
          if (this.nextInLine == null) {
            this.disableButton(this.prevArrow);
          }
          if (this.nextInLine != this.initialNextInLine) {
            this.reableButton(this.nextArrow);
          }
        }
      });

      this.nextArrow.addEventListener('click', () => {
        if (this.lastShown != this.initialLastShown){
          this.offset = this.offset + this.images[this.lastShown].getBoundingClientRect().height;
          this.images.forEach((image) => {
            image.style.transform = `translateY(${this.offset}px)`; 
          });

          this.nextInLine = this.lastShown;
          this.lastShown = this.lastShown - 1;
          if (this.lastShown == this.initialLastShown) {
            this.disableButton(this.nextArrow);
          }
          if (this.nextInLine != null) {
            this.reableButton(this.prevArrow);
          }
        }
      });

      this.querySelector(".main-product__media__arrows").classList.add("__initialized");
    }

    resetSlider() {
      this.nextInLine = this.initialNextInLine;
      this.lastShown = this.initialLastShown;
      this.offset = 0;
      this.disableButton(this.nextArrow);
      this.reableButton(this.prevArrow);

      this.images.forEach((image) => {
        image.style.transform = `translateY(${this.offset}px)`; 
      });


    }

    buildSlider() {
      const ul = this.sliderTemplate?.content.querySelector("ul");

      if (ul) {
        // Clone and append each image <li> from index onward
        for (let i = this.maxStacked; i < this.images.length; i++) {
          const clonedItem = this.images[i].cloneNode(true); // Deep clone the <li>
          ul.appendChild(clonedItem);
        }
      
        // Clone the full template content (with the copied items) and append it to stackedMedia
        const clonedContent = this.sliderTemplate.content.cloneNode(true);
        this.stackedMedia.appendChild(clonedContent);

        this.updateImages();
      }
    }

    updateImages(){
      const updatedImages = [];

      // Add the first untouched <li> elements
      for (let i = 0; i < this.maxStacked && i < this.images.length; i++) {
        updatedImages.push(this.images[i]);
      }

      // Add all <li> elements inside the newly added template clone
      const lastAppendedContent = this.stackedMedia.lastElementChild; // The clone we appended
      if (lastAppendedContent) {
        const newLis = lastAppendedContent.querySelectorAll("li");
        updatedImages.push(...newLis);
      }

      // Redefine this.images with the updated list
      this.images = updatedImages;
    }

    disableButton(button){
      console.log("disable");
      button.disabled = true;
      button.classList.add("__disabled");
    }

    reableButton(button){
      button.disabled = false;
      button.classList.remove("__disabled");
    }

    //utility function used by variant-selects.js
    setActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;

      activeMedia.parentElement.prepend(activeMedia);
    }
  }

  customElements.define('media-gallery', MediaGallery);
}